export const SOCKET_URL = 'https://team.elomia.com';
export const SOCKET_PATH = '/api/socket.io';
export const API_URL = 'https://team.elomia.com/api';
